/**
 * One source of truth for the published legal documents.
 *
 * LEGAL_VERSION must match the <meta name="legal-version"> in all three pages
 * under public/ — tests/e2e/legal.spec.ts asserts they agree. When the
 * documents change materially, bump this and all three pages together.
 *
 * Spec: docs/superpowers/specs/2026-09-12-privacy-compliance-design.md §16.
 */
export const LEGAL_VERSION = '2026-10-30';

export const PRIVACY_EMAIL = 'privacy@hambitower.com';
export const SUPPORT_EMAIL = 'support@hambitower.com';

export const LEGAL_LINKS: ReadonlyArray<{ label: string; href: string }> = [
  { label: 'Privacy Policy', href: '/privacy.html' },
  { label: 'Terms of Use', href: '/terms.html' },
  { label: 'Kids & Parents', href: '/kids-and-parents.html' },
];

/**
 * Shown at the point of collection rather than buried in the policy. PIPEDA's
 * meaningful-consent guidance asks that four things be emphasised where the
 * player is actually deciding: what is collected, who it reaches, what it is
 * for, and any risk. One sentence does all four.
 */
export const CONSENT_SENTENCE =
  'Creating an account stores your email and game progress on servers in the ' +
  'United States so you can play on another device. We never sell your data, ' +
  'and you can ask us to delete it at any time.';
